import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/config";

export function useReviews() {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/reviews`)
      .then((r) => setData(r.data))
      .catch(() => setData({ link: "", reviews: [], connected: false }));
  }, []);

  return data;
}
